var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUrgent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#DDE2F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 26.3307C21.4517 26.3307 24.25 23.5325 24.25 20.0807C24.25 19.2474 24.25 17.5807 22.5833 15.4974C22.5833 15.4974 22.5003 17.8754 20.8552 17.5314C18.1942 16.9751 21.6292 11.7499 16.75 9.66406C16.75 13.8307 11.75 15.0807 11.75 20.0807C11.75 23.5325 14.5482 26.3307 18 26.3307Z",
    stroke: "#0020F5",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9997 23.8316C19.6105 23.8316 20.9163 22.1527 20.9163 20.0816C18.2497 21.0816 17.3053 18.779 17.1663 17.1641C15.9616 17.6251 15.083 19.5187 15.083 20.4974C15.083 22.5685 16.3888 23.8316 17.9997 23.8316Z",
    stroke: "#0020F5",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrgent);
export default __webpack_public_path__ + "static/media/Urgent.40e7baa95f60b1fc31bf9667a8626915.svg";
export { ForwardRef as ReactComponent };